module.exports = __webpack_public_path__ + "static/brand-logo-mesoestetic-1683c0837bb7b842eb0300854904489d.svg";